export default __webpack_public_path__ + "static/media/cardano-ada-logo.d11358fa.svg";